enum FooterBGEnum {
  Dark = 'Dark',
  Light = 'Light',
}

export default FooterBGEnum;
